// ExamProjectManagementPage.tsx

import { useTranslation } from "react-i18next";
import { TaskAlt, Speed, AccountTree } from "@mui/icons-material";
import { useTheme, alpha } from "@mui/material";
import quizApi from "@/services/quizService";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import type { BrandResolver } from "@/types/Portal.types";
import BaseExamPortalPage from "./BaseExamPortalPage";

const getProjectManagementBrand =
  (isDark: boolean): BrandResolver =>
  (item) => {
    const name = item.quizName.toLowerCase();
    if (name.includes("agile") || name.includes("acp")) {
      const accent = isDark ? "#34d399" : "#059669";
      return {
        icon: Speed,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    if (name.includes("prince2")) {
      const accent = isDark ? "#6ee7b7" : "#047857";
      return {
        icon: AccountTree,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    const accent = isDark ? "#4ade80" : "#15803d";
    return {
      icon: TaskAlt,
      accentColor: accent,
      gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
    };
  };

export default function ExamProjectManagementPage() {
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <BaseExamPortalPage
      title={t("pages.examProjectManagement.title")}
      subtitle={t("pages.examProjectManagement.subtitle")}
      actionText={t("pages.examProjectManagement.actionText")}
      themeConfig={{
        activeTabBg: theme.palette.primary.main,
        activeTabTextColor: theme.palette.primary.contrastText,
        borderColor: theme.palette.divider,
      }}
      fetchData={async () => {
        const res = await quizApi.getQuizzes({ search: "ProjectManagement", limit: 99 });
        return res.data;
      }}
      brandResolver={getProjectManagementBrand(isDark)}
      onItemSelect={(item) => navigate(`mock/quiz/${item.quizName}`)}
      isDisabled={true}
    />
  );
}
